import { AfterViewInit, Component, ElementRef } from '@angular/core';

@Component({
  selector: 'screen-column',
  templateUrl: './column.component.html',
  styleUrls: ['./column.component.less']
})
export class SimpleColumnComponent implements AfterViewInit {
  constructor(private _elementRef: ElementRef) {
  }

  ngAfterViewInit() {

  }

}
